export default {
  breadcrumbs: {
    manageEntrants: 'Manage entrants',
    manageEntrantsWithCount: 'Manage entrants ({{count}})',
  },
  container: {
    entrants: 'Entrants ({{count}})',
    entrantsNoCount: 'Entrants',
    revivals: 'Revivals',
    activity: 'Activity',
  },
  comingSoon: {
    title: '{{pageName}} - Coming Soon',
    text: 'This feature is currently in development and will be available soon.',
  },
  entrants: {
    title: 'Entrants',
    cta: 'Manage entrants',
  },
  entries: {
    pageTitle: 'Manage entries',
    backButton: 'Entrants',
    title: 'Entries ({{count}})',
    columnHeader: 'Entry Name',
    loading: 'Loading...',
    noEntriesFound: 'No entries found',
    itemName: 'entries',
    pageSizeLabel: 'Entries per page',
    menu: {
      rename: 'Rename',
      remove: 'Remove',
    },
    unknownUser: 'Unknown User',
    showPick: 'Show pick',
    showAllPicks: 'Show picks',
    showPicksLabel: 'Picks are hidden by default',
    pickMade: 'Pick made',
  },
  noEntrants: {
    title: 'No entrants yet',
    text: 'Go to <bold><link>Invites Manager</link></bold> to invite people to your contest!',
    titleNotAvailable: 'Entrant Manager not available',
    notAvailable:
      'We’re sorry, the Entrant Manager is not available for this contest. If you have any questions please contact <link>customer support</link>.',
    contactSupport: 'customer support',
  },
  noEntries: {
    title: 'No entries yet',
    text: 'This entrant does not have any entries yet.',
  },
  stats: {
    totalEntrants: 'Total Entrants',
    totalEntries: 'Total entries',
    eliminatedEntries: 'Eliminated entries',
    survivingEntries: 'Surviving entries',
    missingPicks: 'Missing Picks',
    entrants: 'Entrants',
    entries: 'Entries',
    avgEntries: 'Avg Entries',
    percent: 'Percent',
  },
  search: {
    placeholder: 'Search entrants by name, handle, or email',
    helperText: 'Please type more characters to search',
  },
  bulkActions: {
    pauseEntrants: 'Pause (all entrants)',
    pauseEntries: 'Pause (all entries)',
    unpauseEntries: 'Unpause (all entries)',
    removeEntries: 'Remove (all entries)',
  },
  table: {
    title: 'Manage entrants',
    download: 'Download',
    search: {
      placeholder: 'Search entrants',
      helperText: 'Please type more characters to search',
    },
    headers: {
      handle: 'ENTRANT',
      name: 'NAME',
      email: 'EMAIL',
      entries: 'ENTRIES',
      enteredAt: 'ENTERED AT',
      entriesMobile: '#',
      entriesWithPicks: 'ENTRIES W/ PICKS',
      needsPicks: 'MISSING PICKS',
      notes: 'NOTES',
      active: 'ALIVE',
      edit: 'EDIT',
    },
    aria: {
      entrantsTable: 'Entrants table',
    },
    pagination: {
      cta: 'Entrants per page',
      display: '{currentRange} of {total} entrants',
    },
    empty: {
      noEntrants: 'No entrants found',
    },
    notes: {
      placeholder: 'Add notes',
    },
    noData: {
      default: {
        title: 'No entries',
        subtitle: 'Invite entrants to your contest to get started.',
      },
      search: {
        title: 'No entries found',
        subtitle:
          "We didn't find any entries that matched your search. You can search for entrants by name, email and handle.",
      },
    },
  },
  modals: {
    bootEntrant: {
      title: 'Warning: Booting entrant is permanent!',
      description:
        'This entrant and all of their entries will be permanently removed from the contest. They will be prevented from joining the contest again. This action can not be undone!',
      descriptionBooted: 'This entrant has already been booted.',
      details: 'Number of Entries that will be removed: {{entries}}',
      submit: 'Boot Entrant',
      cancel: 'Cancel',
    },
    freezeEntrant: {
      title: 'Freeze Entrant',
      description: 'This will prevent entrants from making picks.',
      submit: 'Freeze',
      cancel: 'Cancel',
    },
    unfreezeEntrant: {
      title: 'Unfreeze Entrant',
      description: 'Unfreezing an entrant will allow entrant to make picks.',
      submit: 'Unfreeze',
      cancel: 'Cancel',
    },
    editModal: {
      title: 'ENTRANT INFO',
      labels: {
        name: 'Name:',
        email: 'Email:',
        handle: 'Handle:',
        notesPlaceholder: 'Add notes',
        addNotes: 'Add notes',
      },
      bootEntrant: 'Boot Entrant',
      freezeMember: 'Freeze Entrant',
      unfreezeMember: 'Unfreeze Entrant',
      cta: 'Save changes',
      errors: {
        maxLength: 'Max note length is {{maxNoteLength}} characters',
      },
    },
    download: {
      title: 'Download entrants',
      description: 'Download the list of entrants',
      descriptionLoading: 'Preparing entrants list for download...',
      cta: 'Download .csv',
      failed: {
        title: 'Download Failed',
        description: 'Failed to download entrants. Please try again.',
      },
    },
    sendEmailModal: {
      title: 'Send email',
      to: 'To',
      selectTo: 'Who would you like to send the email to?',
      allEntrants: 'All entrants',
      selectedEntrants: 'Selected entrants',
      missingPicks: 'Missing picks',
      dropdownOptions: {
        alive: 'Alive',
        paused: 'Paused',
        eliminated: 'Eliminated',
        removed: 'Removed',
      },
      from: 'From',
      selectFrom: 'Who would you like the email to come from?',
      fullName: 'Full name',
      splashHandle: 'Splash handle',
      messagePlaceholder: 'Enter custom message here',
      messageLength: '{{length}}/1,000',
      includeLink: 'Include contest invite link in email',
      sendEmail: 'Send email',
    },
    emailsSentConfirmationModal: {
      title: 'Email Sent',
      description: 'You have emailed',
      entrants__hasPlural: 'entrants',
      entrants__one: 'entrant',
    },
    renameEntry: {
      title: 'Rename entry',
      subtitle: 'Rename this entry for',
      subtitle_username: '{{userName}}.',
      saveButton: 'Save changes',
      placeholder: 'Enter entry name',
    },
    warning: 'Warning:',
    pauseEntry: {
      title: 'Pause all entries',
      description: 'Are you sure you want to pause all entries for this entrant?',
      confirmButton: 'Yes, pause all entries',
      cancelButton: 'Cancel',
      warningText:
        'If you do not unpause entries before the pick deadline, then the entries will be eliminated.',
    },
    pauseEntant: {
      title: 'Pause entrants',
      description: 'Are you sure you want to pause these entrants?',
      confirmButton: 'Yes, pause entrants',
      cancelButton: 'Cancel',
      warningText:
        'This action will pause all entries for the entrant. They will not be able to make picks.',
    },
    removeEntry: {
      title__hasPlural: {
        one: 'Remove entry',
        other: 'Remove entries',
      },
      description__hasPlural: {
        one: 'Are you sure you want to remove this entry?',
        other: 'Are you sure you want to remove these entries?',
      },
      confirmButton__hasPlural: {
        one: 'Yes, remove entry',
        other: 'Yes, remove entries',
      },
      cancelButton: 'Cancel',
      warningText__hasPlural: {
        one: 'You are about to permanently remove this entry from the contest.',
        other: 'You are about to permanently remove these entries from the contest.',
      },
    },
    removeAllEntries: {
      title: 'Remove all entries',
      description: 'Are you sure you want to remove all entries for this entrant?',
      confirmButton: 'Yes, remove all entries',
      cancelButton: 'Cancel',
      warningText: 'You are about to permanently remove these entries from the contest.',
    },
    removeEntrant: {
      title__hasPlural: {
        one: 'Remove entrant',
        other: 'Remove entrants',
      },
      description__hasPlural: {
        one: 'Are you sure you want to remove this entrant?',
        other: 'Are you sure you want to remove these entrants?',
      },
      confirmButton__hasPlural: {
        one: 'Yes, remove entrant',
        other: 'Yes, remove entrants',
      },
      cancelButton: 'Cancel',
      warningText__hasPlural: {
        one: 'You are about to permanently remove this entrant and all of their entries from the contest.',
        other:
          'You are about to permanently remove these entrants and all of their entries from the contest.',
      },
    },
    reviveEntry: {
      title: 'Revive Entry',
      description:
        'Are you sure you want to revive this entry? This action will restore the entry to active status.',
      confirmButton: 'Revive Entry',
      cancelButton: 'Cancel',
      warningText:
        'This action cannot be undone. The entry will be restored to active status and may affect contest standings.',
    },
    reviveEntrant: {
      title: 'Revive Entrant',
      description:
        'Are you sure you want to revive this entrant? This action will restore the entrant to active status.',
      confirmButton: 'Revive Entrant',
      cancelButton: 'Cancel',
      warningText:
        'This action cannot be undone. The entrant will be restored to active status and may affect contest standings.',
    },
    reviveModal: {
      title: 'Revive entry',
      description: 'Are you sure you want to revive this entry?',
      confirmButton: 'Yes, revive entry',
      cancelButton: 'Cancel',
    },
  },
  filters: {
    all: 'All',
    needsPicks: 'Missing picks',
    survivors: 'Survivors',
    removed: 'Removed',
    disabled: 'Paused',
    reset: 'Reset',
    notes: 'Notes',
    noNotes: 'No notes',
  },
  buttons: {
    emailEntrants: 'Email entrants',
    email: 'Email',
    download: 'Download',
    faq: 'FAQ',
    manage: 'Manage',
    pause: 'Pause',
    unpause: 'Unpause',
    remove: 'Remove',
  },
  revivals: {
    headerTitle: 'Eliminated entries',
    searchPlaceholder: 'Search entries',
    columns: {
      entryName: 'Entry Name',
      username: 'Username',
      playerName: 'Player Name',
      email: 'Email',
      status: 'Status',
      revivalsToDate: 'Revivals To Date',
    },
    actions: {
      revive: 'Revive',
    },
    status: {
      eliminated: 'Eliminated',
    },
    scheduled: {
      title: "Contest hasn't started yet",
      description: 'Eliminated entries eligible for revival will appear here.',
    },
    inProgress: {
      title: 'No eliminated entries',
      description: 'Eliminated entries eligible for revival will appear here.',
    },
    selectSlate: {
      title: 'Select a slate',
      description: 'Select a slate to see eliminated entries',
    },
  },
  activity: {
    headerTitle: 'Pick activity',
    searchPlaceholder: 'Search activity...',
    searchHelperText: 'Type at least 2 characters to search',
    itemName: 'activity',
    pageSizeLabel: 'Modifications per page',
    columns: {
      dateOfChange: 'DATE OF CHANGE',
      entrant: 'ENTRANT',
      entry: 'ENTRY',
      modification: 'MODIFICATION',
    },
    sorting: {
      defaultSort: 'Sorted by date (newest first)',
      ascending: 'Sorted ascending',
      descending: 'Sorted descending',
    },
    emptyState: {
      title: 'No activity yet',
      text: 'Contest activity will appear here once the contest begins.',
    },
    searchEmptyState: {
      title: 'No activity found',
      text: 'No activity matches your search. Try adjusting your search terms.',
    },
    errors: {
      fetchFailed: 'Failed to load activity data. Please try again.',
      sortNotSupported: 'This column cannot be sorted at this time.',
      retry: 'Retry',
    },
  },
  error: {
    title: 'Error',
    text: 'There was an error fetching the entrants of this contest.',
  },
  validation: {
    entryName: {
      required: 'Entry name is required',
      invalid: 'Entry name must be a valid string',
      maxLength: 'Entry name cannot be longer than {{maxLength}} characters',
      invalidCharacters:
        'Only letters, numbers, hyphen, accented characters and spaces are allowed',
    },
  },
  notifications: {
    entrantRemoved: {
      error: 'Error removing entrant',
      message: 'Entrant removed',
    },
    entrantPaused: {
      error: 'Error pausing entrant',
      message: 'Entrant paused',
    },
    entrantUnpaused: {
      error: 'Error unpausing entrant',
      message: 'Entrant unpaused',
    },
    entryRenamed: {
      error: 'Error renaming entry',
      message: 'Entry renamed to "{{name}}"',
    },
    entryRemoved: {
      error: 'Error removing entry',
      message: 'Entry removed',
    },
    entryRevived: {
      success: 'Entry revived successfully',
      error: 'Error reviving entry',
    },
    successBefore: {
      message: 'Notes updating...',
      sendEmail: 'Sending emails... (this may take a few minutes)',
    },
    successAfter: {
      message: 'Notes updated',
    },
    error: {
      title: 'Error',
      message: 'There was an error updating the notes for this entrant.',
    },
    errorEmail: {
      title: 'Could not send emails',
      message: 'There was an error sending the emails. Please try again later.',
    },
  },
};
